import axios from "@axios"

export default {
  namespaced: false,
  state: {},
  getters: {},
  actions: {
    fetchPlants(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/hro/Orientation/Plant', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPlant(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/hro/Orientation/PlantById/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createPlant(ctx, plantData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/hro/Orientation/CreatePlant', plantData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePlant(ctx, plantData) {
      return new Promise((resolve, reject) => {
        axios
          .put('/hro/Orientation/UpdatePlant', plantData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deletePlant(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .put('/hro/Orientation/DeletePlant', { id: id })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
  mutations: {}
}

